// index.js
import http from "./request";

export function matchSignUp(params) {
  return http.Request("/OutsideBowler/ApplyInMatchSubject", {
    method: "POST",
    params: params,
  });
}

export function loginWeChatByCode(params) {
  return http.Request("/Weixin/TryGongZongLoginByCode", {
    method: "POST",
    params: params,
  });
}

export function registerByCode(params) {
  return http.Request("/Weixin/TryGongZongRegist", {
    method: "POST",
    params: params,
  });
}

export function testWechat() {
  return http.Request("/WeatherForecast", {
    method: "GET",
  });
}
